export default __webpack_public_path__ + "static/media/ICONOS INGLÉS  MI SEGURO SOMIT -11.1f2278db.png";